<script>
    export let color = "currentColor";
    export let width = "100%";

</script>

<div style="width:{width};height:100%;max-width:100%;max-height:100%">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 512 512"
        fill={color}
    >
        <defs>
            <style>
                .cls-1 {
                    fill-rule: evenodd;
                }

            </style>
        </defs>
        <path
            id="Rectangle_1_copy_2"
            data-name="Rectangle 1 copy 2"
            class="cls-1"
            d="M470.248,141.926l0.224,0.224L313.161,299.83,254.007,307.4l-8.809-8.83,7.556-59.293L410.064,81.6l0.224,0.224L440.27,81.6l30.2,30.275ZM304,363v23a5,5,0,0,1-5,5H123a5,5,0,0,1-5-5V363a5,5,0,0,1,5-5H299A5,5,0,0,1,304,363ZM123,281h93.475l-0.364,33H123a5,5,0,0,1-5-5V286A5,5,0,0,1,123,281Zm-5-126V132a5,5,0,0,1,5-5H299a5,5,0,0,1,5,5v15.456L291.486,160H123A5,5,0,0,1,118,155Zm98.961,82H123a5,5,0,0,1-5-5V209a5,5,0,0,1,5-5H247.589l-30.6,30.674ZM335.5,96a5,5,0,0,0-5-5H98.5a5,5,0,0,0-5,5V444a5,5,0,0,0,5,5h232a5,5,0,0,0,5-5V314.24L363,286.676V454a23,23,0,0,1-23,23H89a23,23,0,0,1-23-23V86A23,23,0,0,1,89,63H340a23,23,0,0,1,23,23v2.317l-27.5,27.565V96Z"
        />
    </svg>
</div>
